var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_13)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 141,
    width: 230.028,
    height: 230.028,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.04 290.355L338.636 216.54C331.941 198.029 315.992 184.641 296.853 180.957C304.94 176.195 317.655 164.828 312.218 143.982C311.634 141.735 309.029 140.433 306.827 141.241L215.984 175.251C157.129 196.412 141 248.303 141 320.142V356.623C141 364.575 147.425 371 155.377 371H261.495C272.188 371 279.152 359.768 274.345 350.199L256.014 313.493V313.178C235.527 311.606 218.006 299.386 209.155 281.909C208.436 280.516 208.751 278.809 209.874 277.731L215.31 272.294C217.062 270.542 220.072 271.081 221.106 273.373C227.755 288.513 242.761 299.161 260.372 299.161C268.1 299.161 275.198 296.87 281.398 293.231L302.065 321.939C304.76 325.713 309.118 327.915 313.746 327.915H336.344C340.163 327.915 343.802 326.387 346.498 323.691L366.85 305.81C370.849 301.722 372.107 295.657 370.04 290.355V290.355ZM288.362 241.609C282.387 241.609 277.579 236.802 277.579 230.826C277.579 224.851 282.387 220.044 288.362 220.044C294.337 220.044 299.144 224.851 299.144 230.826C299.144 236.802 294.337 241.609 288.362 241.609Z",
    fill: "#B9BECA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorse);
export default __webpack_public_path__ + "static/media/horse.e8c571cf96bd09ab657eab4441c1061a.svg";
export { ForwardRef as ReactComponent };